import InstagramActionTypes from './instagram.types';

export const fetchInstagramPostsStart = () => ({
	type: InstagramActionTypes.FETCH_INSTAGRAM_POSTS_START,
});

export const fetchInstagramPostsSuccess = posts => ({
	type: InstagramActionTypes.FETCH_INSTAGRAM_POSTS_SUCCESS,
	payload: posts,
});

export const fetchInstagramPostsFailure = errorMessage => ({
	type: InstagramActionTypes.FETCH_INSTAGRAM_POSTS_FAILURE,
	payload: errorMessage,
});
